import {
    ClientDetailModal,
    type ClientDetailModalInitialTab,
} from '@apps/web/components/clients/client_detail_modal';
import { useOrganizationClient } from '@apps/web/swr_data_fetching/data_fetching_hooks';

/**
 * Opens the canonical client detail modal from surfaces that only have an id.
 * Keeping the lookup here prevents every caller from inventing its own adapter.
 */
export function ClientDetailModalById({
    organizationId,
    clientId,
    open,
    onOpenChange,
    onCloseAutoFocus,
    initialTab,
}: {
    readonly organizationId: string;
    readonly clientId: string;
    readonly open: boolean;
    readonly onOpenChange: (open: boolean) => void;
    readonly onCloseAutoFocus?: (event: Event) => void;
    readonly initialTab?: ClientDetailModalInitialTab;
}) {
    const {
        data: client,
        isLoading,
        error,
        mutate,
    } = useOrganizationClient(organizationId, open ? clientId : null, {
        reason: 'client-detail-modal-by-id',
    });

    return (
        <ClientDetailModal
            organizationId={organizationId}
            client={client ?? null}
            isLoading={isLoading || (client === undefined && !error)}
            loadFailed={Boolean(error)}
            onRetry={() => void mutate()}
            initialTab={initialTab}
            open={open}
            onOpenChange={onOpenChange}
            onCloseAutoFocus={onCloseAutoFocus}
        />
    );
}
